import {useEffect, useState} from "react";
import moment from "moment-timezone";
import "moment-timezone";

import useCustomTranslation from "core/customTranslation";
import translations from "../translations";

const IslandsListTable = ({itemsShown, dateHeaders}) => {
    const {t: tC} = useCustomTranslation(translations);

    const cellStyle = {
        maxWidth: "100px",
        minWidth: "100px",
        textAlign: "center",
        verticalAlign: "middle",
        width: "100px",
        height: "58px",
    };

    const renderValue = (val) => {
        if (val === null || val === undefined || val === "") return "-";
        if (typeof val === "number") {
            return val % 1 === 0 ? val : val.toFixed(2).replace(".", ",");
        }
        return val;
    };

    const getLevelColor = (value) => {
        if (value === null || value === undefined) return "transparent";
        if (value >= 75) return "rgba(244, 67, 54, 0.7)";
        if (value >= 50) return "rgba(76, 175, 80, 0.7)";
        if (value >= 30) return "rgba(33, 150, 243, 0.7)";
        return "rgba(255, 235, 59, 0.7)";
    };

    return (
        <div className="col-12" style={{overflowX: "auto"}}>
            <hr className="mb-3" />
            {!itemsShown || itemsShown.length === 0 ? (
                <div className="alert alert-secondary text-center">{tC("filters.noData")}</div>
            ) : (
                <table className="table table-striped" style={{fontSize: "0.85em"}}>
                    <thead>
                        <tr>
                            <th
                                colSpan="2"
                                className="text-center border-start"
                                style={{
                                    borderBottom: "1px solid #7e7e7e",
                                    borderRight: "1px solid #7e7e7e",
                                    verticalAlign: "middle",
                                }}></th>
                            <th
                                colSpan={dateHeaders.length}
                                className="text-center border-start"
                                style={{borderBottom: "1px solid #7e7e7e", verticalAlign: "middle"}}>
                                {tC("tables.dailyLevels")}
                            </th>
                        </tr>
                        <tr>
                            <th className="border-start" style={{width: "120px"}}>
                                {tC("tables.island")}
                            </th>
                            <th style={{borderRight: "1px solid #7e7e7e", width: "100px"}}>{tC("tables.wasteType")}</th>
                            {dateHeaders.map((d, i) => (
                                <th key={i} className="text-center border-start" style={cellStyle}>
                                    {d.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody id="data-list">
                        {itemsShown.map((item, index) => (
                            <tr key={"ilt-" + index}>
                                <td className="border-start">{item.island_name}</td>
                                <td style={{borderRight: "1px solid #7e7e7e"}}>{item.waste_types}</td>
                                {dateHeaders.map((d, i) => {
                                    const hasData = item.daily_levels && d.date in item.daily_levels;
                                    const entry = hasData ? item.daily_levels[d.date] : null;
                                    const bgColor = hasData ? getLevelColor(entry.value) : "transparent";
                                    return (
                                        <td
                                            key={i}
                                            className="text-center border-start data-unloads"
                                            style={{...cellStyle, backgroundColor: bgColor}}>
                                            {hasData ? entry.value + "%" : "-"}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default IslandsListTable;
